(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * Requests suggestions from SAPO Videos for their video resources.
     *
     * Displays suggestions at the end.
     *
     * @namespace sv_suggestions
     */



    // aliases
    var Element = SAPO.Dom.Element,
        Event   = SAPO.Dom.Event,
        Feat    = SAPO.Project.Video.Features;


    if (Feat.isIPhoneOrIPod) { // skip suggestions on iphone-like devices
        return;
    }



    var plugin = function(vc, ui, pub, pubD, v, setOption) {
        this._vc = vc;
        this._ui = ui;
        this._pub = pub;
        this._pubD = pubD;
        this._setOption = setOption;

        this._mode = '';
        this._user = '';
        this._isVisible = false;


        var el = document.createElement('div');
        el.className = 'sv-suggestions fill';
        this._ui._els.aEl.appendChild(el);
        this._el = el;
        this._suggEls = [];

        var divEl;

        divEl = document.createElement('div');
        divEl.className = 'sv-suggestions-wrapper fill';
        this._wrapper = divEl;
        el.appendChild(divEl);
        el = divEl;

        for (var i = 0; i < 4; ++i) {
            divEl = document.createElement('a');
            divEl.className = 'suggestion';
            divEl.setAttribute('target', '_blank');
            divEl.setAttribute('rel', 'external');
            this._suggEls.push(divEl);
            el.appendChild(divEl);
        }

        if ( this._vc.getOption('followSuggestionsInline') ) {
            Event.observe(this._el, 'click',  this._onClick.bindObj(this));
        }

        this._vc.subscribe('ended metadata_changed resize', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'sv_suggestions',

        on_ended: function() {
            if (!this._vc.getOption('skipSuggestions') && this._md && !this._md.isLive && !this._md.isAd && this._mode !== 'none') {
                //console.log('mode: %s, user: %s, hash: %s', this._mode, this._user, this._md.hash);
                if (!this._suggestions) {
                    this._fetchSuggestions();
                }
            }
        },

        on_metadata_changed: function(mt, md) {
            this._md = md;
            this._suggestions = undefined;

            var rvo = this._vc.getOption('relatedVideos');
            var overrideRV = !!rvo;
            if (overrideRV) {
                if (rvo === 'none' || rvo === 'all') {
                    this._mode = rvo;
                    this._user = md.author;
                }
                else {
                    this._mode = 'user';
                    this._user = rvo;
                }
            }
            else {
                this._mode = md.relatedVideos;
                this._user = md.author;
            }

            var aEl;
            for (var i = 0; i < 4; ++i) {
                aEl = this._suggEls[i];
                aEl.innerHTML = '';
            }
        },

        on_resize: function(/*mt, o*/) {

            var el = this._el;
            el.style.visibility = 'hidden'; // so we can measure the element's dimensions
            el.style.display = 'block';

            var maxDims = [
                this._el.offsetWidth,
                this._el.offsetHeight
            ];

            var wEl = this._wrapper;
            var st = wEl.style;

            //console.log('maxDims', maxDims);
            var dims = maxDims.slice();
            var pad = [0, 0];
            var refAR = 16/9;
            var ar = maxDims[0] / maxDims[1];
            if (ar > refAR) {
                //console.log('MAX W');
                dims[0] = Math.round( dims[1] * refAR );
                pad[0] = Math.floor( (maxDims[0] - dims[0]) / 2 );
            }
            else {
                //console.log('MAX H');
                dims[1] = Math.round( dims[0] / refAR );
                pad[1] = Math.floor( (maxDims[1] - dims[1]) / 2 );
            }
            st.width  = dims[0] + 'px';
            st.height = dims[1] + 'px';
            st.margin = [pad[1], 'px ', pad[0], 'px'].join('');

            //console.log('dims', dims);
            //console.log('pad', pad);

            el.style.visibility = '';
            el.style.display    = '';
        },



        _onClick: function(ev) {
            var tgtEl = Event.element(ev);
            var suggAEl = Element.findUpwardsByClass(tgtEl, 'suggestion');
            if (suggAEl) { // inline
                Event.stop(ev);
                var href = suggAEl.getAttribute('href') + '/mov/1';
                this._vc.load(href, true);
            }
        },

        _fetchSuggestions: function() {
            var o = {
                mode:           this._mode,
                hash:           this._md.hash,
                user:           this._user,
                queryDomain:    this._md.queryDomain
            };
            //console.log('FETCHING SUGGESTIONS...');
            SAPO.Project.Video.sapoVideosSuggestions(
                o,
                function(err, res) {
                    //console.log('SUGGESTIONS:', err, JSON.stringify(res, null, '  '));

                    if (err || res.length < 4) {
                        //console.log('NOT ENOUGH SUGGESTIONS: ', res);
                        return;
                    }

                    this._suggestions = res;

                    this._fillSuggestions();
                }.bindObj(this)
            );
        },

        _fillSuggestions: function() {
            //console.log('SETTING FILL SUGGESTIONS...');
            var item, time, imgUrl, aEl, imgEl, divEl;
            for (var i = 0; i < 4; ++i) {
                aEl = this._suggEls[i];
                item = this._suggestions[i];
                aEl.innerHTML = '';

                //imgUrl = item.thumb;

                imgUrl = SAPO.Project.Video.thumbs.cropPosterTransform(
                    item.thumb,
                    [320, 240],
                    [480, 270],
                    item.duration
                );
                time = (item.time.split(':').length === 3) ? item.time.substring(3) : item.time;

                aEl.setAttribute('href', item.url);

                imgEl = document.createElement('div');
                imgEl.className = 'sugg-thumb fill';
                imgEl.style.backgroundImage = 'url(' + imgUrl + ')';

                if (SAPO.Browser.IE && parseInt(SAPO.Browser.version, 10) < 9) {
                    imgEl.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + imgUrl + "', sizingMethod='scale')";
                }

                //imgEl.src = imgUrl;
                aEl.appendChild(imgEl);

                divEl = document.createElement('div');
                divEl.className = 'sugg-title';
                divEl.appendChild( document.createTextNode( item.title ) );
                aEl.appendChild(divEl);

                divEl = document.createElement('div');
                divEl.className = 'sugg-author';
                divEl.appendChild( document.createTextNode( item.author ) );
                aEl.appendChild(divEl);

                divEl = document.createElement('div');
                divEl.className = 'sugg-time';
                divEl.appendChild( document.createTextNode( time ) );
                aEl.appendChild(divEl);
            }
        }

    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
